import { removePropertyEmpty } from '@/utils/index'
import { Service } from '../config'

class SlaService extends Service {
  path = 'sla'

  async get(payload: any) {
    const httpResponse = this.httpClient.get(this.path, {
      params: removePropertyEmpty(payload)
    })
    return httpResponse
  }

  async download(payload: any) {
    const httpResponse = await this.httpClient.get(this.path + '/excel', {
      params: removePropertyEmpty(payload)
    })
    return httpResponse
  }

  async post(params: any) {
    const httpResponse = await this.httpClient.post(
      this.path,
      removePropertyEmpty(params)
    )
    return httpResponse
  }

  async delete(params: any) {
    const httpResponse = await this.httpClient.delete(
      this.path + `?SLAId=${params}`
    )
    return httpResponse
  }

  async put(id: any, params: any) {
    const httpResponse = await this.httpClient.put(
      this.path + `?SLAId=${id}`,
      params
    )
    return httpResponse
  }
}

export const slaService = new SlaService()
